import { DKVColorBoxLabel } from "../../components/ColorBox";
import { Cube } from "../../state/types";
import NitrateIcon from "../icons/NitrateIcon.svg?react";
import { BESI } from "./florafauna/BESI";
import { Section } from "./Section";
import { A, Info } from "./util";

const N2K = ({ data }) => (
  <>
    {", "}
    <span className="italic inline-block">{data.name}</span> <A href={data.url}>Informatie</A>{" "}
    {data.pas ? (
      <span className="inline-block">
        <NitrateIcon className="w-3.5 h-3.5 inline" /> Stiktofgevoelig
      </span>
    ) : null}
  </>
);

const description = (
  <>
    <h5>Beschermde soorten</h5>
    Voor de beschermde soorten wordt de{" "}
    <A href="https://www.bij12.nl/onderwerp/natuurinformatie/applicaties-en-databanken/beschermde-soortenindicator-besi/">
      BEschermde Soorten Indicator
    </A>{" "}
    gebruikt.
    <h5>Natuurgebieden</h5>
    <p>
      Het{" "}
      <A href="https://www.rijksoverheid.nl/onderwerpen/natuur-en-biodiversiteit/natuurnetwerk-nederland">
        Natuurnetwerk Nederland
      </A>{" "}
      is het Nederlands netwerk van bestaande en nieuw aan te leggen natuurgebieden. Het netwerk
      moet natuurgebieden beter verbinden met elkaar en met het omringende agrarisch gebied.
    </p>
    <p>
      <A href="https://www.rijksoverheid.nl/onderwerpen/natuur-en-biodiversiteit/natura-2000">
        Natura 2000
      </A>{" "}
      is een Europees netwerk van beschermde natuurgebieden. In Natura 2000-gebieden worden plant-
      en diersoorten die in Europa bedreigd zijn en hun natuurlijke leefomgeving beschermd om de
      biodiversiteit te behouden.
    </p>
  </>
);

export const SectionFloraFauna = ({ field }: { field: Cube }) => {
  const { nnn, natura2000 } = field?.data || {};
  const besi = field?.rast?.BESI;

  return (
    <Section name="flora" description={description}>
      {nnn || natura2000 ? (
        <Info as="dl">
          <DKVColorBoxLabel k="Natuur Netwerk Nederland" elem={nnn} />
          <DKVColorBoxLabel k="Natura 2000" elem={natura2000} DataComponent={N2K} />
        </Info>
      ) : null}
      <BESI data={besi} />
    </Section>
  );
};
